import { render, staticRenderFns } from "./TitleScreen.vue?vue&type=template&id=3dd46a51&scoped=true&"
import script from "./TitleScreen.vue?vue&type=script&lang=js&"
export * from "./TitleScreen.vue?vue&type=script&lang=js&"
import style0 from "./TitleScreen.vue?vue&type=style&index=0&id=3dd46a51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd46a51",
  null
  
)

export default component.exports